export default __webpack_public_path__ + "static/media/calender.8b9fe792.svg";